import React, { useState, useEffect } from "react";
import plus from "../../../assets/svg/plus-green.svg";

export default function Header({
  setFilteredEvents,
  openEventId,
  setIsAddingEvent,
  isAddingEvent,
  events,
}) {
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (searchText === "") {
      setFilteredEvents(events);
    } else {
      const filtered = events.filter((event) =>
        event.title.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredEvents(filtered);
    }
  }, [searchText, events, setFilteredEvents]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleAddEv = () => {
    setIsAddingEvent(!isAddingEvent);
  };

  return (
    <div className="flex justify-between pb-4 pt-2 pl-2 pr-4">
      <div>
        <input
          className="bg-[#F0F3FA] py-3 px-4 rounded-lg outline-none text-[#5F6B88]"
          type="text"
          placeholder="Поиск по событиям"
          value={searchText}
          onChange={handleSearch}
        />
      </div>
      {!openEventId && !isAddingEvent && (
        <div>
          <button
            onClick={handleAddEv}
            className="flex gap-2 px-6 py-2 rounded-lg text-[#3BBC30] border border-[#3BBC30]"
          >
            <img src={plus} alt="" />
            Создать событие
          </button>
        </div>
      )}
    </div>
  );
}
